import React from "react";
import { withRouter } from "react-router";
import IconSaveForLater from "./icon-save-for-later";
import IconTags from "./icon-tags";
import IconCollection from "./icon-collection";
import LicenseStrip from "./license-strip";
import { modalTypes } from "../../constants/modalTypes";
import { connect } from "react-redux";
import * as actions from "../../actions/actions";

const PhaseInitial = props => {
    return (
        <div>
            <IconCollection {...props} />
            <LicenseStrip
                license={props.download.iconBaseLicense}
                icon={props.download.pendingDownload}
            />
            <div className="download-actions">
                <IconDownload {...props} />
                <IconSaveForLater {...props} />
            </div>
            <IconTags {...props} />
        </div>
    );
};

export default PhaseInitial;

let IconDownloadRaw = props => {
    let {
        history,
        download,
        downloadRequest,
        downloadFlowNavigateToModalStep
    } = props;
    let { loggedIn } = download;
    let onClick = React.useCallback(() => {
        if (loggedIn) {
            downloadRequest();
        } else {
            downloadFlowNavigateToModalStep(history, modalTypes.AUTH);
        }
    }, [history, downloadRequest, downloadFlowNavigateToModalStep, loggedIn]);

    return (
        <button
            className="button green download-flow-start-button"
            onClick={onClick}
        >
            Get this icon
        </button>
    );
};

export const IconDownload = withRouter(
    connect(null, {
        downloadFlowNavigateToModalStep: actions.downloadFlowNavigateToModalStep
    })(IconDownloadRaw)
);
